<template>
  <div class="seat-block">
    <div class="seat-wrap saloon">
      <div class="train-number">{{ props.carNumber }}号車　サルーン</div>
      <div
        v-if="
          props.carNumberVacancyStatus.car.boarding_gate_position == 'forward'
        "
        class="gate"
      >
        乗車口
      </div>
      <div
        v-else-if="
          props.carNumberVacancyStatus.car.boarding_gate_position ==
          'forward_only_metro'
        "
        class="gate"
      >
        乗車口(東京メトロ線内のみ)
      </div>
      <div
        v-for="row_index in Math.ceil(
          props.carNumberVacancyStatus.seats.length / 5
        )"
        :key="row_index"
        class="row"
      >
        <div
          v-for="(seat, index) in props.carNumberVacancyStatus.seats.slice(
            (row_index - 1) * 5,
            (row_index - 1) * 5 + 5
          )"
          :key="seat.display_number"
          :style="isHidden(row_index, index)"
        >
          <button
            v-if="seat.seat_attribute != 0"
            class="button"
            :class="[checkSelected(seat).flag ? 'select' : '']"
            type="button"
            :disabled="!seat.vacancy"
            @click="arrangeSelectedSeat(seat)"
          >
            <div class="row-front">
              <div class="seat"></div>
              <div class="seat"></div>
            </div>
            <div class="row-number">
              <div>{{ seat.display_number }}</div>
            </div>
            <div class="row-rear">
              <div class="seat"></div>
              <div class="seat"></div>
            </div>
          </button>
        </div>
      </div>
      <div
        v-if="props.carNumberVacancyStatus.car.boarding_gate_position == 'back'"
        class="gate"
      >
        乗車口
      </div>
      <div
        v-else-if="
          props.carNumberVacancyStatus.car.boarding_gate_position ==
          'back_only_metro'
        "
        class="gate"
      >
        乗車口(東京メトロ線内のみ)
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useVModel } from "vue-composable";

export default {
  name: "MFITTSeatMapSaloon",

  props: {
    carNumber: {
      type: Number,
      required: false,
    },
    carNumberVacancyStatus: {
      type: Object,
      required: false,
      default: null,
    },
    selectedSeat: {
      type: Array,
      required: false,
      default: null,
    },
    inputtedInfoOnBooking: {
      type: Object,
      required: false,
      default: null,
    },
  },
  emits: ["checkSeatsCount"],
  setup(props, { emit }) {
    const selectedSeat = useVModel(props, "selectedSeat");

    // 座席がすでに選ばれているかをチェックする
    const checkSelected = computed(() => {
      return function (seat) {
        let flag;
        let index;
        selectedSeat.value.some(function (ob, i) {
          if (ob.seat.seat_number === seat.seat_number) {
            flag = true;
            index = i;
          }
        });
        return { flag: flag, index: index };
      };
    });

    // 座席ボタンが叩かれたとき、その座席がすでに選ばれているかをチェックしその結果に応じて追加・削除を行う
    const arrangeSelectedSeat = (seat) => {
      const some = checkSelected.value(seat);
      if (some.flag) {
        selectedSeat.value.splice(some.index, 1);
        emit("checkSeatsCount", false);
      } else {
        // ４名まで１座席なので、
        // 人数の合計値 / 4 の切り上げが選択すべきテーブルの数
        const totalTableCount = Math.ceil(
          (props.inputtedInfoOnBooking.adult_count +
            props.inputtedInfoOnBooking.child_count) /
            4
        );
        if (totalTableCount > selectedSeat.value.length) {
          const object = { car_number: 3, seat: seat };
          selectedSeat.value.push(object);
        }
        if (totalTableCount == selectedSeat.value.length) {
          emit("checkSeatsCount", true);
        }
      }
    };

    // 301A 301A 0 301B 301B
    // 301A 301A 0 301B 301B
    // 303C 303C 0 0    0
    // 303C 303C 0 0    0
    // このレスポンスで返ってくる
    // 2行目、4行目を削除
    // 2列目、4列目を削除
    // 3列目を削除
    const isHidden = (row_index, index) => {
      return row_index % 2 == 0 || index == 2 || index % 2 == 0
        ? { display: "none" }
        : "";
    };

    return {
      selectedSeat,
      checkSelected,
      arrangeSelectedSeat,
      isHidden,
      props,
    };
  },
};
</script>

<style lang="scss" scoped>
.seat-block {
  width: 100%;
}
.seat-block .seat-wrap {
  border: 6px solid #c32a2a;
  background-color: #f7e7d2;
  border-radius: 12px;
  padding: 8px 8px;
}

.seat-block .seat-wrap .row {
  display: flex;
  justify-content: space-between;
  margin: 6px 0;
}
.seat-block .seat-wrap .row .button {
  background-color: #ffffff;
  border: 2px solid #c9713a;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  width: 100%;
  height: 40px;
  color: #c9713a;
  font-size: 18px;
  font-weight: bold;
  margin-right: 8px;
}
.seat-block .seat-wrap .row .button:last-of-type {
  margin-right: 0;
}
.seat-block .seat-wrap .row .button:nth-of-type(2) {
  margin-right: 18px;
}
.seat-block .seat-wrap .row .button.select {
  background-color: #ffb206;
  border-color: #ffdc8e;
  color: #ffffff;
}
.seat-block .seat-wrap .row .button:disabled {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(201, 113, 58, 0.2);
  color: rgba(201, 113, 58, 0.2);
}

.seat-block .seat-wrap .train-number {
  text-align: center;
  width: 100%;
  margin: 14px 0;
  color: #000000;
  font-size: 16px;
  line-height: 16px;
  font-weight: bold;
}

.seat-block .seat-wrap .gate {
  background-color: #066796;
  text-align: center;
  width: 100%;
  margin: 14px 0;
  padding: 12px 0;
  color: #ffffff;
  font-size: 16px;
  line-height: 16px;
  font-weight: normal;
}

/* サルーン用ボックスCSS */
.seat-block .seat-wrap.saloon .row {
  margin-bottom: 12px;
}
.seat-block .seat-wrap.saloon .row div {
  width: 49%;
}
.seat-block .seat-wrap.saloon .row .button {
  border-radius: 0;
  height: 120px;
  padding: 0;
  margin-right: 12px;
}
.seat-block .seat-wrap.saloon .row .button:nth-of-type(2) {
  margin-right: 0;
}
.seat-block .seat-wrap.saloon .row .button .row-front,
.seat-block .seat-wrap.saloon .row .button .row-rear {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: 36px;
}
.seat-block .seat-wrap.saloon .row .button .row-front {
}
.seat-block .seat-wrap.saloon .row .button .row-front .seat,
.seat-block .seat-wrap.saloon .row .button .row-rear .seat {
  background-color: #ffffff;
  width: 40%;
  height: 34px;
  margin: 0 0 0 4px;
  padding: 0;
}
.seat-block .seat-wrap.saloon .row .button .row-front .seat {
  border: 2px solid #c9713a;
  border-top: none;
  border-radius: 0;
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
}
.seat-block .seat-wrap.saloon .row .button .row-rear .seat {
  border: 2px solid #c9713a;
  border-bottom: none;
  border-radius: 0;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
}
.seat-block .seat-wrap.saloon .row .button .row-front .seat:nth-of-type(2),
.seat-block .seat-wrap.saloon .row .button .row-rear .seat:nth-of-type(2) {
  margin: 0 4px 0 0;
}
.seat-block .seat-wrap.saloon .row .button.select .row-front .seat,
.seat-block .seat-wrap.saloon .row .button.select .row-rear .seat {
  background-color: #ffb206;
  border-color: #ffdc8e;
  color: #ffffff;
}
.seat-block .seat-wrap.saloon .row .button:disabled .row-front .seat,
.seat-block .seat-wrap.saloon .row .button:disabled .row-rear .seat {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(201, 113, 58, 0.2);
  color: rgba(201, 113, 58, 0.2);
}
.seat-block .seat-wrap.saloon .row .button .row-number {
  display: block;
  width: 100%;
  height: 44px;
  text-align: center;
}
.seat-block .seat-wrap.saloon .row .button .row-number div {
  display: inline-block;
  font-size: 18px;
  font-weight: bold;
  color: #c9713a;
  padding-top: 10px;
}
.seat-block .seat-wrap.saloon .row .button.select .row-number div {
  color: #ffffff;
}
.seat-block .seat-wrap.saloon .row .button:disabled .row-number div {
  color: rgba(201, 113, 58, 0.2);
}
.seat-block .seat-wrap.saloon .row .button.blank-space:disabled {
  background-color: rgba(255, 255, 255, 0);
  border-color: rgba(201, 113, 58, 0);
  color: rgba(201, 113, 58, 0);
}
</style>
